import axios from "axios";

const API = (process.env.REACT_APP_API_URL || "http://localhost:8000/api").replace(/\/$/, "");

export const fetchEndoscopyTests = async (token, params = {}) => {
  const headers = token ? { Authorization: `Token ${token}` } : {};
  const res = await axios.get(`${API}/endoscopy-tests/`, { headers, params });
  return res.data;
};

export const createEndoscopyTest = async (token, payload) => {
  const headers = token ? { Authorization: `Token ${token}` } : {};
  const res = await axios.post(`${API}/endoscopy-tests/`, payload, { headers });
  return res.data;
};

export const updateEndoscopyTest = async (token, id, payload) => {
  const headers = token ? { Authorization: `Token ${token}` } : {};
  const res = await axios.patch(`${API}/endoscopy-tests/${id}/`, payload, { headers });
  return res.data;
};

export const deleteEndoscopyTest = async (token, id) => {
  const headers = token ? { Authorization: `Token ${token}` } : {};
  await axios.delete(`${API}/endoscopy-tests/${id}/`, { headers });
};

export const fetchEndoscopyRecords = async (token, params = {}) => {
  const headers = token ? { Authorization: `Token ${token}` } : {};
  const res = await axios.get(`${API}/endoscopy-records/`, { headers, params });
  return res.data;
};

export const createEndoscopyRecord = async (token, formData) => {
  const headers = token ? { Authorization: `Token ${token}` } : {};
  if (typeof FormData !== "undefined" && formData instanceof FormData) {
    headers["Content-Type"] = "multipart/form-data";
  }
  const res = await axios.post(`${API}/endoscopy-records/`, formData, { headers });
  return res.data;
};

export const updateEndoscopyRecord = async (token, id, payload) => {
  const headers = token ? { Authorization: `Token ${token}` } : {};
  if (typeof FormData !== "undefined" && payload instanceof FormData) {
    headers["Content-Type"] = "multipart/form-data";
  }
  const res = await axios.patch(`${API}/endoscopy-records/${id}/`, payload, { headers });
  return res.data;
};

export const deleteEndoscopyRecord = async (token, id) => {
  const headers = token ? { Authorization: `Token ${token}` } : {};
  await axios.delete(`${API}/endoscopy-records/${id}/`, { headers });
};
